module.exports = __webpack_public_path__ + "img/phone_icon.564de82f.png";